import { SalesChannelModel } from "./sales-channel-model.model";

export class CalcRunId {
    public calRunId: any;
    public salesChanls: any;
    constructor() {
        this.calRunId = null;
        this.salesChanls = [];
    }
}
